<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp">
    <container>
      <div class="user__list-offer">

        <!--//components-->
        <offers/>
        <!--//components-->

      </div>
    </container>
  </div>
</template>

<script>
import Offers from '@/components/Offers'

export default {
  name: 'UserOffers',
  components: {
    Offers
  }
}
</script>

<style lang="scss">

</style>
